import TableComponent from '../../../Common/Charts/TableCharts';
import { number } from '../../../Common/Util/number';
import { useDetailsChartsDataContext } from './hooks/useDetailsChartsDataContext';
import { useSanitizeData } from '../../Common/hooks/useSanitizeData';

export const CircumstanceMonthList = () => {
    const { chartData } = useDetailsChartsDataContext();

   const monthNames = [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Maio',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez'
    ];

    const tableColumns = [
            {
                key: 'ano_registro_bo',
                header: 'Ano',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'mes_registro_bo',
                header: 'Mês',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'circunstancia',
                header: 'Circunstância',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'total',
                header: 'Total',
                headerStyle: { fontWeight: '700', textAlign: 'right' },
                cellStyle: { textAlign: 'right', fontWeight: '400' },
                formatter: (value) => number.formatToBRNumber(value)
            }
    ];

    const rawData = chartData?.circumstanceEvolutionMonth || [];
    
    console.log('chartData', chartData);
    console.log('rawData', rawData);

    const flattenedData = rawData.flatMap((itemAno) => {
        return itemAno.circunstancias.map((circunstancia) => ({
            ...circunstancia,
            ano_registro_bo: itemAno.ano_registro_bo,
            mes_registro_bo: monthNames[itemAno.mes_registro_bo - 1]
        }));
    });
    
    const sanitizedData = useSanitizeData(flattenedData);

    return (
        <div style={{ width: '100%' }}>
            <TableComponent
                data={sanitizedData}
                columns={tableColumns}
                title="Circunstâncias Mensais"
                showTotal={true}
                totalColumn="total"
                formatNumber={number.formatToBRNumber}
                maxHeight="600px"
            />
        </div>
    );
};